import { useEffect, useState } from "react";
import logo from '../public/assets/images/Logo.svg'

export default function LogoImg() {
    const [isSmallDevice, setIsSmallDevice] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isSmallDevice: MediaQueryList = window.matchMedia("(max-width: 320px)")
            setIsSmallDevice(isSmallDevice.matches);
        }
    }, [isSmallDevice]);

    return (
        <img className="header-logo" src={logo} alt="Logo" width={isSmallDevice ? 74 : 124} height={74} />
    )
}
